var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.changeVisibility,
          expression: "changeVisibility",
        },
      ],
      staticClass: "reference-uniform-list-category",
      class: {
        "reference-uniform-list-category-sticky": _vm.sticked,
        "reference-uniform-list-category-border-bottom-none":
          !_vm.category.isVisible && !_vm.last,
        "cursor-pointer": _vm.hasChildren,
      },
      attrs: { id: "category_" + _vm.category.id },
      on: {
        click: function ($event) {
          _vm.hasChildren ? _vm.$emit("toggle") : ""
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "b-popover",
              rawName: "v-b-popover.html",
              value: {
                container: "#app",
                trigger: "hover blur",
                boundary: "window",
                content: !_vm.hasChildren ? "Пустая категория" : "",
                placement: "top",
              },
              expression:
                "{\n      container: '#app',\n      trigger: 'hover blur',\n      boundary: 'window',\n      content: !hasChildren ? 'Пустая категория' : '',\n      placement: 'top',\n    }",
              modifiers: { html: true },
            },
          ],
          staticClass: "reference-uniform-list-category-show-button",
          class: {
            collapsed: _vm.category.isVisible,
            "not-collapsed": !_vm.category.isVisible,
            "reference-uniform-list-category-show-button-disabled":
              !_vm.hasChildren,
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "8",
                height: "5",
                viewBox: "0 0 8 5",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z",
                  fill: "#0066FF",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z",
                  fill: "#0066FF",
                },
              }),
            ]
          ),
        ]
      ),
      _c("div", { staticClass: "reference-uniform-list-category-content" }, [
        _c("div", { staticClass: "reference-uniform-list-category-name" }, [
          _vm._v(" " + _vm._s(_vm.category.name) + " "),
          !_vm.hasChildren
            ? _c("span", { staticClass: "empty" }, [_vm._v("(пусто)")])
            : _vm._e(),
        ]),
        _vm.responsible
          ? _c(
              "div",
              { staticClass: "reference-uniform-list-category-responsible" },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: `/index.php?r=redesign#/personal-employee/${_vm.responsible.id}/summary`,
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.responsible.name))]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "reference-uniform-list-category-buttons" },
        [
          _vm.category.descriptionModel.hasDescription
            ? _c("c-button", {
                staticClass: "reference-uniform-list-category-buttons-comment",
                attrs: { size: "iconic", icon: "comment" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("showDescription")
                  },
                },
              })
            : _vm._e(),
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  boundary: "window",
                  content: "Редактировать",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: 'Редактировать',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "reference-uniform-list-category-buttons-edit",
            attrs: { size: "iconic", icon: "edit" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$emit("edit")
              },
            },
          }),
          !_vm.hasChildren
            ? _c("c-button", {
                directives: [
                  {
                    name: "b-popover",
                    rawName: "v-b-popover.html",
                    value: {
                      container: "#app",
                      trigger: "hover blur",
                      boundary: "window",
                      content: "Удалить",
                      placement: "top",
                    },
                    expression:
                      "{\n        container: '#app',\n        trigger: 'hover blur',\n        boundary: 'window',\n        content: 'Удалить',\n        placement: 'top',\n      }",
                    modifiers: { html: true },
                  },
                ],
                staticClass: "reference-uniform-list-category-buttons-trash",
                attrs: { size: "iconic", icon: "trash" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.$emit("remove")
                  },
                },
              })
            : _vm._e(),
          _vm.hasChildren
            ? _c("c-button", {
                staticClass:
                  "reference-uniform-list-category-buttons-trash reference-uniform-list-category-buttons-trash-disabled",
                attrs: {
                  id: "category_empty_" + _vm._uid,
                  size: "iconic",
                  icon: "trash",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              })
            : _vm._e(),
          _c(
            "b-popover",
            {
              attrs: {
                placement: "top",
                container: "app",
                boundary: "window",
                target: "category_empty_" + _vm._uid,
                triggers: "hover blur",
              },
            },
            [
              _c(
                "div",
                { staticClass: "reference-uniform-category-empty-tooltip" },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "reference-uniform-category-empty-tooltip-icon",
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          fill: "white",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "reference-uniform-category-empty-tooltip-text",
                    },
                    [
                      _vm._v(
                        " В данный момент удаление невозможно, так как категория содержит данные. Сначала перенесите все данные из категории. "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }